export enum CodeType {
  DISCOUNT = 'DISCOUNT',
  RESTORATION = 'RESTORATION',
  UNLOCK = 'UNLOCK',
  INSTANT_UNLOCK = 'INSTANT_UNLOCK',
}

export interface DetectCodeTypeRequest {
  code: string;
}

export interface ValidateUnlockCodeRequest {
  code: string;
}

export interface ValidateDiscountCouponRequest {
  code: string;
  shortLink: string;
}

export interface CodeInfo {
  code: string;
  type: CodeType;
  issuanceInfo: string | null;
}

export interface UnlockCodeInfo {
  code: string;
  productTitle: string;
  productShortlink: string;
  issuanceInfo: string | null;
}

export interface DiscountCodeInfo {
  code: string;
  discount: number;
}
